import { inject, Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { GroupApiCallService } from './group-api-call.service';
import { HeaderColumn } from '../../../shared/models/shared.model';
import { GroupListData, TableResponse } from '../models/group-management.model';

@Injectable({ providedIn: 'root' })
export class GroupListService {
    private groupApiCallService = inject(GroupApiCallService);

    private groupListAttributes = signal<HeaderColumn[]>([]);
    private currentGroup = signal<string>('');

    getCurrentGroup() {
        return this.currentGroup();
    }

    getGroupListAttributes() {
        return this.groupListAttributes();
    }

    loadGroupListAttributes(groupType: string): void {
        this.currentGroup.set(groupType);

        const groupListAttributes: HeaderColumn[] = [
            { key: 'name', label: 'Group' },
            { key: 'description', label: 'Description' },
            { key: 'tenantName', label: 'Tenant' },
        ];

        switch (this.getCurrentGroup()) {
            case 'EntityGroups':
                groupListAttributes.push({
                    key: 'totalEntities',
                    label: 'Total entities',
                });
                break;
            case 'ContentGroups':
                groupListAttributes.push(
                    { key: 'sportsCount', label: 'Sports' },
                    { key: 'regionsCount', label: 'Regions' },
                    { key: 'tournamentCount', label: 'Tournaments' },
                );
                break;
            case 'MarketTypeGroups':
                groupListAttributes.push(
                    { key: 'totalMarkets', label: 'Total markets' },
                    { key: 'sportName', label: 'Sport' },
                );
                break;
            case 'RuleRangeGroups':
                groupListAttributes.push({
                    key: 'rangeType',
                    label: 'Range type',
                });
                groupListAttributes.push({
                    key: 'ruleType',
                    label: 'Rule type',
                });
                break;
            default:
                throw new Error(
                    `Unknown group type: ${this.getCurrentGroup()}`,
                );
        }

        groupListAttributes.push({ key: 'isAbsolute', label: 'Is Absolute' });

        this.groupListAttributes.set(groupListAttributes);
    }

    getGroupListData(pagination?: {
        pageNo: number;
        pageSize: number;
    }): Observable<TableResponse> {
        return this.groupApiCallService.getGroupListData(
            this.currentGroup(),
            pagination,
        );
    }

    updateGroupSelection(data: GroupListData): Observable<any> {
        return this.groupApiCallService.updateGroupSelection(
            this.getCurrentGroup(),
            data.id,
            data.isActive,
        );
    }

    /** Deletes a group of the current group type (AB#8675). */
    deleteGroup(id: number): Observable<void> {
        return this.groupApiCallService.deleteGroupData(
            this.getCurrentGroup(),
            id,
        );
    }
}
